
import { motion } from 'framer-motion';

export default function FixedBackgroundSection() {
  return (
    <div className="h-screen bg-fixed bg-cover bg-center relative" style={{
      backgroundImage: 'url("/static/images/bg_process_testomonials_main.jpg")'

    }}>
      <div className="h-full bg-black/50 flex items-center justify-end margin-left-60 pr-60">
        <motion.div 
          className="text-center text-white px-4"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h3 className="text-4xl md:text-5xl font-bold mb-6">Building Success Together</h3>
          <p className="text-xl md:text-2xl max-w-2xl mx-auto mb-8">
            Your commercial real estate goals are our priority
          </p>
          <motion.button
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-4 bg-emerald-500 text-white rounded-lg font-semibold hover:bg-emerald-600 transform hover:scale-105 transition-all duration-300 shadow-lg"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Start Your Project
          </motion.button>
        </motion.div>
      </div>
    </div>
  );
}
